import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Tooltip, Zoom } from '@material-ui/core';
import './styles.css';
import Heading from '../../UI/Texts/Heading';
import Paragraph from '../../UI/Texts/Paragraph';
import { formatMoney } from '../../Common/decimalHelper';

const ClientazoTooltip = withStyles((theme) => ({
  tooltip: {
    background: '#EFF0F8 0% 0% no-repeat padding-box',
    boxShadow: '0px 3px 6px #00000029',
    borderRadius: '4px',
    padding: '0px',
    opacity: '1 !important',
    margin: '7px 0 4px 25px !important'
  },
}))(Tooltip);

const VisualizadorPrecio = ({ precioLista, precioPromocional, porcentajeDescuentoFullCatalogo }) => {
    const tienePromocionValida = precioPromocional && precioPromocional < precioLista;

  const renderPrecioFormateado = (precio) => {
    if (precio === null || precio === undefined) return '';
    const formatted = formatMoney(precio);
    const parts = formatted.split(',');
    if (parts.length === 2) {
      return (
        <span className="vp-precioContenedor">
          <span className="vp-precioEntero">{parts[0]}</span>
          <span className="vp-precioDecimales">{parts[1]}</span>
        </span>
      );
    }
    return formatted;
  };

  const renderPrecioNormal = (precio) => {
    if (precio === null || precio === undefined) return '';
    return formatMoney(precio);
  };

  return (
    <div className='visualizadorPrecio'>
      {tienePromocionValida ? 
      <Paragraph size='medium' weight='semi_bold'>
        Antes <span className='precioTachado vp-precioNormal'>{renderPrecioNormal(precioLista)}</span>
      </Paragraph> 
      :
      <>
      {porcentajeDescuentoFullCatalogo > 0? 
        <Paragraph size='medium' weight='semi_bold'>
        <span className='precioTachado vp-precioNormal'>{renderPrecioNormal(precioLista)}</span>
        </Paragraph>
      :
      <Heading tag='h3' weight='bold'>
        {renderPrecioFormateado(precioLista)}
      </Heading>
      }
      </>
      }
      {tienePromocionValida &&
      <Heading tag='h3' weight='bold'>{renderPrecioFormateado(precioPromocional)}</Heading>      
      }

      {(precioPromocional === null && porcentajeDescuentoFullCatalogo && porcentajeDescuentoFullCatalogo > 0) ? <Heading tag='h3' weight='bold'>{renderPrecioFormateado(precioLista-precioLista*porcentajeDescuentoFullCatalogo/100)}</Heading> : <span></span>}
    </div>
  );
};

VisualizadorPrecio.defaultProps = {
  precioLista: 0,
  precioPromocional: undefined
};

VisualizadorPrecio.propTypes = {
  precioLista: PropTypes.number,
  precioPromocional: PropTypes.number,
};

export default VisualizadorPrecio;
